module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-backplates.c05933b9.png";